import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { ExtendedLicenseTable } from "./LicensingPage";

export function makeLicenseFields(): FilterField<ExtendedLicenseTable>[] {
  const fields: FilterField<ExtendedLicenseTable>[] = [
    {
      label: "Subscription",
      key: "subscription",
      accessor: (r) => r.subscription,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Start Date",
      key: "startdate",
      accessor: (r) => r.startdate,
      type: "string",
      inFreeText: true,
    },
    {
      label: "End Date",
      key: "enddate",
      accessor: (r) => r.enddate,
      type: "string",
      inFreeText: true,
    },
    {
      label: "License",
      key: "serial",
      accessor: (r) => r.id.toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Type",
      key: "type",
      accessor: (r) => r.type,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description,
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

